module.exports = __webpack_public_path__ + "img/icon-generic-generic6.7ee2cefd.svg";